import React from 'react';
import styled from '@emotion/styled';
import Responsive from '../../../../../../ui/utils/Responsive';
import { Column, ColumnHeader } from './Column';
import { ScheduledTime } from '../../../../shared/time/ui';

interface IProps {
	scheduledTimestamp: number;
	bestKnownTimestamp: number;
	isDelayed: boolean;
	arrival: boolean;
	role?: 'columnheader' | 'cell';
}

export const StyledTimeColumn = styled(({ role = 'columnheader', ...props }) =>
	role === 'columnheader' ? <ColumnHeader {...props} /> : <Column {...props} />,
)`
	max-width: 120px;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		max-width: 90px;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobile')}) {
		max-width: 80px;
		font-size: 14px;
	}
`;

export const TimeColumn = ({
	scheduledTimestamp,
	bestKnownTimestamp,
	isDelayed,
	arrival,
	role,
}: IProps) => (
	<StyledTimeColumn role={role}>
		<ScheduledTime
			arrival={arrival}
			isDelayed={isDelayed}
			scheduledTimestamp={scheduledTimestamp}
			bestKnownTimestamp={bestKnownTimestamp}
		/>
	</StyledTimeColumn>
);
